import React from "react";
import { useAuth } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Login from "@/pages/Login";
import PatientApp from "@/pages/PatientApp";
import StaffDashboard from "@/pages/StaffDashboard";
import Logo from "@/components/Logo";
import LocationButton from "@/components/LocationButton";

function LoadingScreen() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-5">
      <Logo size={72} className="animate-pulse" />
      <span className="w-5 h-5 border-2 border-[#2E6CA4] border-t-transparent rounded-full animate-spin360" />
    </div>
  );
}

export default function App() {
  const { user, loading } = useAuth();

  // Detect Google OAuth callback synchronously during render (prevents race conditions)
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  if (loading) return <LoadingScreen />;

  let screen;
  if (!user) {
    screen = <Login />;
  } else if (user.role === "medico" || user.role === "recepcion") {
    screen = <StaffDashboard />;
  } else {
    screen = <PatientApp />;
  }

  return (
    <>
      {screen}
      <LocationButton />
    </>
  );
}
